import React, { useEffect } from 'react';
import Button from '../Button';

type LogoutConfirmationModalProps = {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
};

export default function LogoutConfirmationModal({ isOpen, onConfirm, onCancel }: LogoutConfirmationModalProps) {
    useEffect(() => {
        if (!isOpen) return;

        const handleEscape = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                onCancel();
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [isOpen, onCancel]);

    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
            onClick={onCancel}
        >
            <div
                className="w-full max-w-md rounded-xl border border-gray-200 bg-white p-6 shadow-xl dark:border-gray-700 dark:bg-gray-800"
                onClick={(e) => e.stopPropagation()}
            >
                <h2 className="mb-3 text-lg font-semibold text-gray-900 dark:text-gray-100">
                    Confirm Logout
                </h2>
                <p className="mb-6 text-sm text-gray-600 dark:text-gray-400">
                    Are you sure you want to logout? This action cannot be undone.
                </p>
                <div className="flex gap-3">
                    <Button
                        variant="secondary"
                        onClick={onCancel}
                        className="flex-1"
                    >
                        No, Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={onConfirm}
                        className="flex-1 bg-red-600 hover:bg-red-700 focus:ring-red-500"
                    >
                        Yes, Logout
                    </Button>
                </div>
            </div>
        </div>
    );
}
